/**
 * RoleBasedRedirect Component
 * Redirects users to their default route based on their role
 */

import React from 'react'
import { Navigate } from 'react-router-dom'

import { useAuthStore } from '@/features/auth/authStore'
import { getDefaultRouteForRole } from '@/utils/roleBasedRouting'
import { ROUTES } from '@/utils/routes'

/**
 * RoleBasedRedirect - Redirects authenticated users to their role-specific default page
 * Redirects to login if user is not authenticated
 */
export const RoleBasedRedirect: React.FC = () => {
  // Authentication state is strictly managed by AuthProvider before Router renders
  // We can safely rely 100% on the synchronous Zustand store here.
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const user = useAuthStore((s) => s.user)

  // If no token, redirect to login immediately
  if (!isAuthenticated || !user) {
    return <Navigate to={ROUTES.LOGIN} replace />
  }

  // Determine redirect route based on user roles
  const defaultRoute = getDefaultRouteForRole(user.roles)

  return <Navigate to={defaultRoute} replace />
}

export default RoleBasedRedirect
